module.exports = __webpack_public_path__ + "static/media/volunteer2.1c8ef2b1.png";